import { MessageCircle } from "lucide-react";
import { LANGS } from "../i18n";
import { BOOKING_URL, waUrl } from "../config";
import { trackCta, withAttribution } from "../attribution";

export const Nav = ({ t, lang, setLang }) => (
    <header
        data-testid="main-nav"
        className="fixed top-0 inset-x-0 z-50 border-b border-[#1b0b06]/10 bg-[#fbf3e8]/85 backdrop-blur-md"
    >
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-2.5 sm:px-6">
            <a href="#top" data-testid="nav-logo-link" aria-label="Matianellu Hostel">
                <img src="/logo.png" alt="Matianellu Rio" className="h-9 w-auto sm:h-11" />
            </a>
            <div className="flex items-center gap-1.5 sm:gap-3">
                <div className="flex items-center gap-0.5 rounded-full border border-[#1b0b06]/15 p-0.5" data-testid="lang-switcher">
                    {LANGS.map((l) => (
                        <button
                            key={l}
                            data-testid={`lang-${l}-btn`}
                            onClick={() => setLang(l)}
                            className={`rounded-full px-2.5 py-1 text-xs font-bold uppercase tracking-wider transition-colors ${
                                lang === l
                                    ? "bg-[#1b0b06] text-[#fbf3e8]"
                                    : "text-[#1b0b06]/60 hover:text-[#1b0b06]"
                            }`}
                        >
                            {l}
                        </button>
                    ))}
                </div>
                <a
                    href={waUrl(t.waMsg)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="nav-whatsapp-btn"
                    onClick={trackCta("whatsapp_click", "header")}
                    className="hidden items-center gap-1.5 rounded-full border border-[#1b0b06]/15 px-3 py-1.5 text-xs font-bold uppercase tracking-wider text-[#1b0b06] transition-colors hover:bg-[#25d366] hover:text-white sm:flex"
                >
                    <MessageCircle size={14} />
                    {t.nav.talk}
                </a>
                <a
                    href={withAttribution(BOOKING_URL)}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={trackCta("book_now_click", "header")}
                    data-testid="nav-book-btn"
                    className="rounded-full bg-[#f23218] px-4 py-2 text-xs font-bold uppercase tracking-wider text-white shadow-[0_4px_14px_rgba(242,50,24,0.35)] transition-transform hover:scale-105"
                >
                    {t.nav.book}
                </a>
            </div>
        </div>
    </header>
);
